module.exports = __webpack_public_path__ + "static/media/card_presto.6fc1545a.svg";